export default __webpack_public_path__ + "static/media/logo-electracaldense.361a9a59.png";